import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';

const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const cardStyle = {
  background: 'linear-gradient(135deg, #f8fbff 0%, #e3f0ff 100%)',
  boxShadow: '0 4px 24px 0 rgba(0, 60, 180, 0.08)',
  borderRadius: '18px',
  border: '1px solid #e0e7ef',
  margin: '2rem auto',
  padding: '2.5rem 2rem',
  maxWidth: 900,
  transition: 'box-shadow 0.3s',
  fontFamily: '"Poppins", "Segoe UI", Arial, sans-serif',
  position: 'relative',
};

const cardHoverStyle = {
  boxShadow: '0 8px 32px 0 rgba(0, 60, 180, 0.16)',
};

const headerStyle = {
  color: '#1976d2',
  fontWeight: 700,
  letterSpacing: 1,
  margin: '0.5rem 0',
};

const subHeaderStyle = {
  color: '#1565c0',
  fontWeight: 500,
  margin: '0.2rem 0',
};

const infoLabel = {
  color: '#1976d2',
  fontWeight: 600,
};

const infoValue = {
  color: '#333',
  fontWeight: 500,
};

const avatarBorder = {
  border: '3px solid #1976d2',
  background: '#fff',
};

const gradingBox = {
  background: '#e3f0ff',
  borderRadius: 8,
  padding: '0.5rem 1rem',
  margin: '0.5rem 0',
  color: '#1976d2',
  fontWeight: 500,
  fontSize: 14,
};

const AcademicPrintAll = ({ students, selectedterm, Class_, schooldata }) => {
  const [hovered, setHovered] = React.useState(-1);
  const [selectedTerm, setSelectedTerm] = React.useState(selectedterm || '');
  const [showPosition, setShowPosition] = React.useState(true);
  const [showGradePoint, setShowGradePoint] = React.useState(true);
  const [showAttendance, setShowAttendance] = React.useState(true);
  const [showClassPosition, setShowClassPosition] = React.useState(true);
  const [showAggregate, setShowAggregate] = React.useState(true);
  const [showPromotion, setShowPromotion] = React.useState(true);
  const [showDomainAssessment, setShowDomainAssessment] = React.useState(true);
  const [showToddlerAssessment, setShowToddlerAssessment] = React.useState(false);
  const [showSpecialExams, setShowSpecialExams] = React.useState(true);
  const [roundValues, setRoundValues] = React.useState(true);
  const [promotionStatuses, setPromotionStatuses] = React.useState({});
  const dt = new Date();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = `${year}-${month}-${day}`;
  const school = schooldata && schooldata[0] ? schooldata[0] : {};

  // Helper function to round decimal values
  const roundDecimal = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return Math.round(num);
  };

  // Helper function to round decimal values with 2 decimal places
  const roundDecimalToTwo = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return Math.round(num * 100) / 100;
  };

  // Helper function to format values based on rounding toggle
  const formatValue = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    
    if (roundValues) {
      // When toggle is ON: Round to 2 decimal places
      return (Math.round(num * 100) / 100).toFixed(2);
    } else {
      // When toggle is OFF: Round to whole numbers
      return Math.round(num);
    }
  };

  // Helper function to handle promotion status changes
  const handlePromotionStatusChange = (studentId) => {
    setPromotionStatuses(prev => ({
      ...prev,
      [studentId]: prev[studentId] === "Promoted" ? "Repeated" : "Promoted"
    }));
  };

  // Get unique terms from students' academics2
  const availableTerms = React.useMemo(() => {
    const terms = new Set();
    students.forEach(student => {
      if (student.academics2) {
        student.academics2.forEach(academic => {
          if (academic.termName) {
            terms.add(academic.termName);
          }
        });
      }
    });
    return Array.from(terms);
  }, [students]);

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', alignItems: 'center' }}>
          <FormControl style={{ minWidth: 200 }} className="no-print">
            <InputLabel id="term-select-label">Select Term</InputLabel>
            <Select
              labelId="term-select-label"
              value={selectedTerm}
              onChange={(e) => setSelectedTerm(e.target.value)}
              label="Select Term"
            >
               <MenuItem value="none">
                                <em>Choose Term</em>
                            </MenuItem>
                            {school && school.terms && school.terms.length!==0?
                            school.terms.map((list,index)=>
                            <MenuItem value={list}>{list}</MenuItem>

                            ) :""   
                        }
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.print()}
            style={{
              padding: '0.8rem 2rem',
              fontSize: '16px',
              fontWeight: 600,
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
            }}
          >
            Print All Reports
          </Button>
        </div>
        <Box className="no-print" sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <FormControlLabel
            control={<Switch checked={showPosition} onChange={(e) => setShowPosition(e.target.checked)} />}
            label="Show Position"
          />
          <FormControlLabel
            control={<Switch checked={showGradePoint} onChange={(e) => setShowGradePoint(e.target.checked)} />}
            label="Show Grade Point"
          />
          <FormControlLabel
            control={<Switch checked={showAttendance} onChange={(e) => setShowAttendance(e.target.checked)} />}
            label="Show Attendance"
          />
          <FormControlLabel
            control={<Switch checked={showClassPosition} onChange={(e) => setShowClassPosition(e.target.checked)} />}
            label="Show Class Position"
          />
          <FormControlLabel
            control={<Switch checked={showAggregate} onChange={(e) => setShowAggregate(e.target.checked)} />}
            label="Show Aggregate"
          />
          <FormControlLabel
            control={<Switch checked={showPromotion} onChange={(e) => setShowPromotion(e.target.checked)} />}
            label="Show Promotion"
          />
          <FormControlLabel
            control={<Switch checked={showDomainAssessment} onChange={(e) => setShowDomainAssessment(e.target.checked)} />}
            label="Show Domain Assessment"
          />
          <FormControlLabel
            control={<Switch checked={showToddlerAssessment} onChange={(e) => setShowToddlerAssessment(e.target.checked)} />}
            label="Toddler Assessment"
          />
          <FormControlLabel
            control={<Switch checked={showSpecialExams} onChange={(e) => setShowSpecialExams(e.target.checked)} />}
            label="Show Special Exams"
          />
          <FormControlLabel
            control={<Switch checked={roundValues} onChange={(e) => setRoundValues(e.target.checked)} />}
            label="Round Values"
          />
        </Box>
        <style>
          {`
            body, .print-section {
              font-family: 'Segoe UI', Arial, sans-serif;
              font-size: 12px;
              font-weight: 400;
              background: #f4f8fb;
            }
            .report-table th, .report-table td {
              font-size: 12px;
              font-family: inherit;
            }
            .report-table th {
              font-weight: 700;
              background: #e3f0ff;
              color: #1976d2;
              padding: 6px;
              border: 1px solid #1976d2;
            }
            .report-table td {
              padding: 6px;
              border: 1px solid #1976d2;
            }
            .report-table td:first-child {
              text-align: left;
            }
            .report-table tr:nth-child(even) {
              background: #f8fbff;
            }
            .student-header {
              font-weight: 700;
              color: #1976d2;
              font-size: 14px;
              margin-bottom: 0.2em;
            }
            .student-id {
              color: #333;
              font-weight: 500;
              font-size: 12px;
            }
            .section-label {
              font-weight: 600;
              color: #1565c0;
              margin-top: 1em;
              margin-bottom: 0.5em;
              font-size: 12px;
            }
            @media print {
              body * {
                visibility: hidden !important;
              }
              .print-section, .print-section * {
                visibility: visible !important;
                font-family: 'Segoe UI', Arial, sans-serif !important;
                font-size: 12px !important;
                font-weight: 400 !important;
              }
              .print-section {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: white;
              }
              .print-btn, .MuiButton-root {
                display: none !important;
              }
              .pagebreak {
                page-break-after: always;
              }
              .student-page {
                page-break-before: always;
                page-break-after: always;
                break-before: page;
                break-after: page;
                padding-top: 10px;
              }
              .student-page:first-child {
                page-break-before: auto;
                break-before: auto;
                padding-top: 0;
              }
              @page {
                size: A4;
                margin: 0mm;
                margin-left: 10px;
                margin-right: 10px;
              }
            }
            .no-print {
              @media print {
                display: none !important;
              }
            }
            
            /* Promotion Toggle Styles */
            @media print {
              .promotion-toggle {
                display: none !important;
              }
              .promotion-print-only {
                display: inline !important;
              }
            }
            .promotion-print-only {
              display: none;
            }
          `}
        </style>
      </div>

      <div className="print-section" style={{ background: '#f4f8fb', minHeight: '100vh', pageBreakInside: 'avoid' }}>
        {/* Google Fonts */}
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap" rel="stylesheet" />
        {students.map((chosen, index) => {
          const academicRecord = chosen.academics2?.find(academic => academic.termId === selectedTerm);
          console.log("academicRecord")
          console.log(chosen.academics2)

          // Determine subject types for this student's class and split subjects
          const classEntry = Array.isArray(Class_)
            ? Class_.find(bug => bug.classname === chosen.class_) || Class_[0]
            : null;

          console.log('Class Entry Debug:', {
            classEntry: classEntry,
            className: chosen.class_,
            hasSubjects: classEntry && Array.isArray(classEntry.subjects),
            subjectsArray: classEntry?.subjects
          });

          // Handle nested array structure: subjects might be [[{...}, {...}]] or [{...}, {...}]
          let classSubjects = [];
          if (classEntry && Array.isArray(classEntry.subjects)) {
            // Check if first element is an array (nested structure)
            if (classEntry.subjects.length > 0 && Array.isArray(classEntry.subjects[0])) {
              // Flatten the nested array
              classSubjects = classEntry.subjects[0];
              console.log('Detected nested array structure, flattened:', classSubjects);
            } else {
              // Normal array structure
              classSubjects = classEntry.subjects;
            }
          }

          const subjectTypeMap = {};

          // Build map using both subject ID and subject name as keys
          classSubjects.forEach((subj, idx) => {
            console.log(`Class Subject ${idx}:`, subj);
            
            if (subj && subj.subject !== undefined && subj.subject !== null) {
              const key = String(subj.subject).trim();
              const type = (subj.type || '').trim();
              subjectTypeMap[key] = type;
              
              console.log(`Mapped: "${key}" -> type: "${type}"`);
              
              // Also map by subject name if it exists and is different
              if (subj.subjectName && String(subj.subjectName).trim() !== key) {
                subjectTypeMap[String(subj.subjectName).trim()] = type;
                console.log(`Also mapped by name: "${String(subj.subjectName).trim()}" -> type: "${type}"`);
              }
            }
          });

          console.log('Final subjectTypeMap:', subjectTypeMap);

          const allSubjects = (academicRecord?.subjects || []);
          const mainSubjects = [];
          const specialExamSubjects = [];

          allSubjects.forEach(subject => {
            // Try matching by subjectId first
            const subjId = subject.subjectId !== undefined ? String(subject.subjectId).trim() : '';
            // Fallback to subjectName if subjectId doesn't match
            const subjName = subject.subjectName !== undefined ? String(subject.subjectName).trim() : '';
            
            // Try to find type by subjectId, then by subjectName
            const rawType = subjectTypeMap[subjId] || subjectTypeMap[subjName] || '';
            const typeLower = rawType.toLowerCase().trim();

            console.log('Subject matching:', {
              subjectId: subjId,
              subjectName: subjName,
              foundType: rawType,
              typeLower: typeLower,
              isSpecialExam: typeLower === 'special exams',
              availableKeys: Object.keys(subjectTypeMap)
            });

            if (typeLower === 'special exams') {
              specialExamSubjects.push(subject);
            } else {
              mainSubjects.push(subject);
            }
          });

          // Debug: Log counts
          console.log('Subject counts:', {
            total: allSubjects.length,
            main: mainSubjects.length,
            specialExams: specialExamSubjects.length,
            classSubjectsCount: classSubjects.length
          });

          return (
            <div
              key={chosen.id || chosen.ID || index}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(-1)}
              className="student-page"
            >
              <Container style={{ padding: 0 }}>
                <div>
                  <div style={{ textAlign: 'center' }}>
                    <Grid container style={{ marginBottom: '10px' }} alignItems="center">
                     <br/>
                     <br/>
                      <Grid item xs={8}>
                        <img
                          src={school.image ? `https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/logothumb/${school.image}` : ''}
                          width="80px"
                          alt="schoologo"
                          style={{ boxShadow: '0 2px 8px #b3c6e0', marginTop:"20px"}}
                        />
                        <div className="student-header"  style={{marginBottom:"-15px"}}>{school.schoolname && school.schoolname.toUpperCase()}</div>
                        <div className="section-label" style={{marginBottom:"-2px"}}>{school.address && school.address.toUpperCase()}</div>
                        <div style={{ color: '#1976d2', fontWeight: 500, marginBottom:"15px" }}>{school.contact}</div>
                      </Grid>
                      <Grid item xs={4} style={{ borderLeft: '2px solid #e0e7ef', textAlign: 'center', paddingLeft: 12 }}>
                        <Avatar
                          style={{ width: 100, height: 100, margin: '4px auto 8px', ...avatarBorder }}
                          alt={chosen.lastname}
                          src={chosen.image ? `https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/thumbnail/${chosen.image}` : ''}
                        />
                        <div style={{ marginTop: 8 }}>
                          <div className="student-header" style={{marginBottom:"-5px"}}>
                            {(chosen.lastname || '').toUpperCase()} {(chosen.othernames || '').toUpperCase()}
                          </div>
                          <div className="student-id">ID : {chosen.id || chosen.ID}</div>
                        </div>
                      </Grid>
                    </Grid>
                    <Divider style={{ margin: '1rem 0', background: '#1976d2', height: 2, borderRadius: 2 , marginTop:"-10px"}} />
                    <Grid container spacing={1} justifyContent="center" style={{ marginBottom: 8 }}>
                      <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                        <span className="section-label">Class: </span>
                        <span>{chosen.class_}</span>
                      </Grid>
                      <Grid align="left" item xs={12} sm={6} md={4}  style={{marginBottom:"-7px"}}>
                        <span className="section-label">Number On Roll: </span>
                        <span>{students.filter(bug => bug.class_ === chosen.class_).length}</span>
                      </Grid>
                      <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                        <span className="section-label">Date: </span>
                        <span>{months[parseInt(date.split('-')[1]) - 1]} {date.split('-')[2]}, {date.split('-')[0]}</span>
                      </Grid>
                      <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                        <span className="section-label">Term: </span>
                        <span>{selectedTerm}</span>
                      </Grid>
                      <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                        <span className="section-label">Re-opening Date: </span>
                        <span>{school.reopendate ? `${months[parseInt(school.reopendate.split('-')[1]) - 1]} ${school.reopendate.split('-')[2]}, ${school.reopendate.split('-')[0]}` : 'Set Re-opening Date'}</span>
                      </Grid> 
                      {showAttendance && (
                        <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                          <span className="section-label">Attendance: </span>
                          <span>{selectedTerm !== 'none' && academicRecord && academicRecord.aggregateResults?.attendanceScore ? formatValue(academicRecord.aggregateResults?.attendanceScore) : 0}
                          </span>
                        </Grid>
                      )}
                      <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                      </Grid>
                    </Grid>
                    {showToddlerAssessment ? (
                      // Toddler Assessment Table
                      <table className="report-table" style={{ width: '100%', borderCollapse: 'collapse', margin: '1.5rem 0' }}>
                        <thead>
                          <tr>
                            <th>Subject</th>
                            <th>Category</th>
                            <th>Milestone</th>
                            <th>Rating</th>
                            <th>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(academicRecord?.subjects || []).map((subject, idx) => {
                            // Find toddler assessments for this subject
                            const toddlerAssessments = subject.assessments?.filter(assessment => 
                              assessment.type === 'assess toddlers' && assessment.toddlerData
                            ) || [];
                            
                            if (toddlerAssessments.length === 0) {
                              return (
                                <tr key={idx}>
                                  <td>{(subject.subjectName || subject.subjectId || '').toUpperCase()}</td>
                                  <td colSpan="4" style={{ textAlign: 'center', color: '#666' }}>No toddler assessments</td>
                                </tr>
                              );
                            }
                            
                            return toddlerAssessments.map((assessment, assessmentIdx) => (
                              <tr key={`${idx}-${assessmentIdx}`}>
                                <td>{assessmentIdx === 0 ? (subject.subjectName || subject.subjectId || '').toUpperCase() : ''}</td>
                                <td>{assessment.toddlerData?.category || 'N/A'}</td>
                                <td>{assessment.toddlerData?.milestone || 'N/A'}</td>
                                <td style={{ 
                                  fontWeight: 'bold',
                                  color: assessment.toddlerData?.rating === 'Outstanding' ? '#2e7d32' :
                                         assessment.toddlerData?.rating === 'Excellent' ? '#1976d2' :
                                         assessment.toddlerData?.rating === 'Very Good' ? '#388e3c' :
                                         assessment.toddlerData?.rating === 'Good' ? '#f57c00' :
                                         assessment.toddlerData?.rating === 'Satisfactory' ? '#ff8f00' :
                                         assessment.toddlerData?.rating === 'Emerging' ? '#f9a825' :
                                         assessment.toddlerData?.rating === 'Developing' ? '#f57f17' :
                                         assessment.toddlerData?.rating === 'Needs Improvement' ? '#d84315' :
                                         assessment.toddlerData?.rating === 'Requires Support' ? '#c62828' :
                                         assessment.toddlerData?.rating === 'Not Observed' ? '#666' : '#333'
                                }}>
                                  {assessment.toddlerData?.rating || 'N/A'}
                                </td>
                                <td style={{ fontSize: '12px', maxWidth: '200px', wordWrap: 'break-word' }}>
                                  {assessment.toddlerData?.notes || 'N/A'}
                                </td>
                              </tr>
                            ));
                          })}
                        </tbody>
                      </table>
                    ) : (
                      // Regular Academic Table
                      <>
                        <table className="report-table" style={{ width: '100%', borderCollapse: 'collapse', margin: '1.5rem 0' }}>
                          <thead>
                            <tr>
                              <th>Subject</th>
                              <th>Class Score ({academicRecord?.classScale || 50}%)</th>
                              <th>Exams Score ({academicRecord?.examScale || 50}%)</th>
                              <th>Total Score ({((academicRecord?.classScale || 0) + (academicRecord?.examScale || 0)) || 100}%)</th>
                              {/* <th>Grade</th> */}
                              {showGradePoint && <th>Grade Point</th>}
                              {showPosition && <th>Position</th>}
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mainSubjects.map((subject, idx) => {
                              const classScore = parseFloat(subject.classScore) || 0;
                              const examScore = parseFloat(subject.examScore) || 0;
                              const totalScore = (classScore + examScore).toFixed(2);
                              return (
                                <tr key={idx}>
                                  <td>{(subject.subjectName || subject.subjectId || '').toUpperCase()}</td>
                                  <td>{formatValue(subject.classScore)}</td>
                                  <td>{formatValue(subject.examScore)}</td>
                                  <td>{formatValue(totalScore)}</td>
                                  {/* <td>{subject.grade || ''}</td> */}
                                  {showGradePoint && <td>{formatValue(subject.gradePoint)}</td>}
                                  {showPosition && <td>{subject.position || ''}</td>}
                                  <td>{subject.remarks || ''}</td>
                                </tr>
                              );
                            })}
                            <tr style={{ backgroundColor: '#e3f0ff', fontWeight: 'bold' }}>
                              <td colSpan="3">Total Score</td>
                              <td colSpan={showGradePoint && showPosition ? 5 : showGradePoint || showPosition ? 4 : 3}>
                                {formatValue(
                                  mainSubjects.reduce((total, subject) => {
                                    const classScore = parseFloat(subject.classScore) || 0;
                                    const examScore = parseFloat(subject.examScore) || 0;
                                    return total + classScore + examScore;
                                  }, 0) || 0
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <Divider style={{ margin: '1.5rem 0', background: '#1976d2', height: 2, borderRadius: 2 }} />
                {(() => {
                  // Debug logging
                  console.log('Grid Container Debug:', {
                    showToddlerAssessment,
                    showAggregate,
                    showClassPosition,
                    showPromotion,
                    classEntry: classEntry,
                    classEntryAggregate: classEntry?.aggregate,
                    classEntryPosition: classEntry?.position,
                    selectedTerm: selectedTerm,
                    isThirdTerm: selectedTerm && selectedTerm.split(' Term ')[0] === '3rd'
                  });
                  return null;
                })()}
                <Grid container spacing={1} justifyContent="center" style={{ marginBottom: 8 }}>
                  <Grid align="left" item xs={12} sm={6} md={4}>
                    {!showToddlerAssessment && showAggregate && classEntry && (
                      <div style={{marginBottom:"-7px"}}>
                        <span className="section-label">Aggregate: </span>
                        <span style={{ color: '#333', fontWeight: 700 }}>
                          {/*
                            AGGREGATE CALCULATION EXPLANATION (UPDATED):
                            1. Get the academic record for the selected term from chosen.academics2.
                            2. Get the list of "core" subject IDs for the student's class from Class_[0].subjects (subjects with type 'core').
                            3. From the student's subjects for the term, separate those that are "core" and those that are not, using Class_[0].subjects for type lookup (by subjectId).
                            4. For the "core" subjects, collect their grade points (convert to int if string), and include subject name and type.
                            5. For the other (non-core) subjects, pick the two with the least (lowest) grade points, and include subject name and type.
                            6. List each grade point and subject name, separated with comma (console.log), and show if subject is core or not.
                            7. Output only the sum.
                            8. Use least, not highest, for the two non-core.
                            9. Additionally, console.log all the core subjects and the two least (non-core) subjects with their grade points, names, and type.
                            10. Console.log all the grade points from the student's academic record for the selected term, with subject name and type.
                            11. Console.log the Class_ data as well.
                            12. Console.log all core subjects (from Class_[0].subjects).
                            Note: "core" subjects are those with type 'core' in Class_[0].subjects.
                            Note: When checking subject type, use Class_[0].subjects and match by subjectId (not subjectName).
                          */}
                          {(() => {
                            // Get class subjects for this student's class
                            const classSubjects =
                              Array.isArray(Class_) &&
                              Class_.find(bug => bug.classname === chosen.class_) &&
                              Array.isArray(Class_.find(bug => bug.classname === chosen.class_).subjects)
                                ? Class_.find(bug => bug.classname === chosen.class_).subjects
                                : (Class_[0] && Array.isArray(Class_[0].subjects) ? Class_[0].subjects : []);

                            // Build subject type map: subjectId -> type (Core / Elective / Special Exams)
                            const subjectTypeMap = {};
                            classSubjects.forEach(subj => {
                              if (subj && subj.subject !== undefined && subj.subject !== null) {
                                subjectTypeMap[String(subj.subject).trim()] = subj.type || '';
                              }
                            });

                            // 1. Get the academic record for the selected term
                            const record = chosen.academics2?.find(academic => academic.termId === selectedTerm);
                            if (!record || !Array.isArray(record.subjects)) return 0;

                            // Helper to normalise grade point
                            const parseGradePoint = (gp) => {
                              if (typeof gp === 'string') {
                                const parsed = parseInt(gp, 10);
                                return isNaN(parsed) ? 0 : parsed;
                              }
                              if (typeof gp === 'number') return gp;
                              return 0;
                            };

                            // Build list of subject grade points for this term,
                            // excluding "Special Exams" subjects
                            const allTermGradePoints = record.subjects
                              .map(subj => {
                                const subjId = subj.subjectId !== undefined ? String(subj.subjectId).trim() : '';
                                const subjName = (subj.subjectName || '').trim();
                                const rawType = subjectTypeMap[subjId] || 'Elective';
                                const typeLower = rawType.toLowerCase();

                                // Exclude Special Exams from aggregate computation
                                if (typeLower === 'special exams') {
                                  return null;
                                }

                                return {
                                  subject: subjName,
                                  subjectId: subjId,
                                  gradePoint: parseGradePoint(subj.gradePoint),
                                  type: typeLower,
                                };
                              })
                              .filter(Boolean);

                            // Core subjects with grade points, name, and type
                            const coreGradePointsWithNames = allTermGradePoints.filter(obj => obj.type === 'core');

                            // Other (non-core) subjects, pick two with least grade points
                            const otherGradePointsWithNames = allTermGradePoints
                              .filter(obj => obj.type !== 'core')
                              .sort((a, b) => a.gradePoint - b.gradePoint)
                              .slice(0, 2);

                            // Combine and sum
                            const allGradePointsWithNames = [...coreGradePointsWithNames, ...otherGradePointsWithNames];

                            let totalGradePoints = 0;
                            allGradePointsWithNames.forEach(obj => {
                              totalGradePoints += obj.gradePoint;
                            });

                            return totalGradePoints;
                          })()}
                          {/* {selectedTerm !== 'none' && academicRecord && academicRecord.aggregateResults?.bestSixTotal ? formatValue(academicRecord.aggregateResults?.bestSixTotal) : 0} */}
                        </span>
                      </div>
                    )}
                    {!showToddlerAssessment && showPromotion && classEntry && (
                      <div style={{marginBottom:"-7px"}}>
                        <span className="section-label" style={{ color: '#388e3c', fontWeight: 600 }}>
                          {selectedTerm && selectedTerm.split(' Term ')[0] === '3rd' ? 'Promoted to:' : 'Next Class:'}{' '}
                        </span>
                        <span
                          className="promotion-toggle"
                          style={{
                            cursor: "pointer",
                            color: "#1976d2",
                            fontWeight: 700,
                            borderBottom: "1px dashed #1976d2",
                            userSelect: "none"
                          }}
                          onClick={() => handlePromotionStatusChange(chosen.id || chosen.ID)}
                        >
                          {(() => {
                            const nextClass = classEntry?.nextclass;
                            const studentId = chosen.id || chosen.ID;
                            const promotionStatus = promotionStatuses[studentId] || "Promoted";
                            return promotionStatus === "Promoted" ? (nextClass || "Next Class") : "Repeated";
                          })()}
                        </span>
                        <span className="promotion-print-only" style={{ display: 'none' }}>
                          {(() => {
                            const nextClass = classEntry?.nextclass;
                            const studentId = chosen.id || chosen.ID;
                            const promotionStatus = promotionStatuses[studentId] || "Promoted";
                            return promotionStatus === "Promoted" ? (nextClass || "Next Class") : "Repeated";
                          })()}
                        </span>
                      </div>
                    )}
                  </Grid>
                  {!showToddlerAssessment && showClassPosition && classEntry && (
                    <Grid align="left" item xs={12} sm={6} md={4} style={{marginBottom:"-7px"}}>
                      <span className="section-label" style={{ color: '#d32f2f', fontWeight: 700 }}>Position in class: </span>
                      <span style={{ color: '#d32f2f', fontWeight: 700 }}>
                        {selectedTerm !== 'none' && academicRecord && academicRecord.aggregateResults?.overallPosition ? academicRecord.aggregateResults?.overallPosition : 0}
                      </span>
                    </Grid>
                  )}
                </Grid>

                        {/* Special Exams Table */}
                        {showSpecialExams && specialExamSubjects.length > 0 && (
                          <div style={{ margin: '1.5rem 0' }}>
                            <div style={{ 
                              textAlign: 'center', 
                              marginBottom: '0.5rem',
                              fontWeight: 700,
                              fontSize: '16px',
                              color: '#1976d2'
                            }}>
                              SPECIAL EXAMS
                            </div>
                            <div style={{ 
                              textAlign: 'center', 
                              marginBottom: '1rem',
                              fontSize: '12px',
                              color: '#666',
                              fontStyle: 'italic'
                            }}>
                              Note: These scores are not added to the main academic scores.
                            </div>
                            <table
                              className="report-table"
                              style={{ width: '100%', borderCollapse: 'collapse', margin: '1.5rem 0' }}
                            >
                              <thead>
                                <tr>
                                  <th>Special Exam Subject</th>
                                  <th>Score</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                {specialExamSubjects.map((subject, idx) => {
                                  const classScore = parseFloat(subject.classScore) || 0;
                                  const examScore = parseFloat(subject.examScore) || 0;
                                  const totalScore = (classScore + examScore).toFixed(2);
                                  return (
                                    <tr key={idx}>
                                      <td>{(subject.subjectName || subject.subjectId || '').toUpperCase()}</td>
                                      <td>{formatValue(totalScore)}</td>
                                      <td>{subject.remarks || ''}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                <Divider style={{ margin: '0.15rem 0', background: '#1976d2', height: 1, borderRadius: 1 }} />

                <Grid container spacing={0.5}>
                  
                  <Grid item xs={12} sm={4}><span className="section-label" style={{ marginBottom: 0.5 }}>Class Teacher's Remarks:</span></Grid>
                  <Grid item xs={12} sm={8}><span style={{ marginBottom: 0.5 }}>{selectedTerm !== 'none' && academicRecord && academicRecord.aggregateResults?.overallRemarks ? academicRecord.aggregateResults?.overallRemarks : ""}
                  </span></Grid>
                </Grid>
                {/* Domain Assessment Section */}
                {showDomainAssessment && (
                  <div style={{ margin: '1.5rem 0' }}>
                                    <Divider style={{ margin: '0.15rem 0', background: '#1976d2', height: 1, borderRadius: 1 }} />

                    <p className="section-label" style={{ textAlign: 'center', color: '#1976d2', fontWeight: 700, letterSpacing: 1, marginBottom: 16 }}>
                      DOMAIN ASSESSMENT
                    </p>
                    <Grid container spacing={2}>
                      {/* Affective Domain Table */}
                      <Grid item xs={6} md={6}>
                        <div style={{ marginBottom: 16 }}>
                          <div style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8, textAlign: 'center' }}>AFFECTIVE DOMAIN</div>
                          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 8 }}>
                            <thead>
                              <tr>
                                <th style={{ border: '1px solid #1976d2', background: '#e3f0ff', color: '#1976d2', fontWeight: 700, fontSize: 12, padding: 3, minWidth: 120, textAlign: 'left' }}> </th>
                                {[5,4,3,2,1].map(score => (
                                  <th key={score} style={{ border: '1px solid #1976d2', background: '#e3f0ff', color: '#1976d2', fontWeight: 700, fontSize: 12, padding: 3, width: 25 }}>{score}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {[
                                'Honesty', 'Neatness', 'Politeness', 'Punctuality/assembly', 'Self-control/calmness', 'Obedience', 'Reliability', 'Approaches new task with Positive attitude', 'Sense of responsibility', 'Relationship with others', 'Uses class time appropriately to complete task', 'Follows instructions with minimal supervision', 'Seeks clarification or assistance when needed', 'Complete and submit task according to agreed-upon timelines', 'Set individual goals and monitors progress towards achieving them'
                              ].map((item, idx) => (
                                <tr key={item}>
                                  <td style={{ border: '1px solid #1976d2', padding: 3, fontSize: 12 }}>{item}</td>
                                  {[5,4,3,2,1].map(score => (
                                    <td key={score} style={{ border: '1px solid #1976d2', textAlign: 'center', fontSize: 12, color: '#1976d2', fontWeight: 700 }}>
                                      {academicRecord?.domainAssessment?.affective?.[item] === score ? '✓' : ''}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Grid>
                      {/* Psychomotor Domain Table */}
                      <Grid item xs={6} md={6}>
                        <div>
                          <div style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8, textAlign: 'center' }}>PSYCHOMOTOR DOMAIN</div>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr>
                                <th style={{ border: '1px solid #1976d2', background: '#e3f0ff', color: '#1976d2', fontWeight: 700, fontSize: 12, padding: 3, minWidth: 120, textAlign: 'left' }}>HANDLING OF TOOLS</th>
                                {[5,4,3,2,1].map(score => (
                                  <th key={score} style={{ border: '1px solid #1976d2', background: '#e3f0ff', color: '#1976d2', fontWeight: 700, fontSize: 12, padding: 3, width: 25 }}>{score}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {[
                                'Drawing or Painting', 'Handwriting', 'Public Speaking', 'Speech Fluency', 'Sports and Games'
                              ].map((item, idx) => (
                                <tr key={item}>
                                  <td style={{ border: '1px solid #1976d2', padding: 3, fontSize: 12 }}>{item.toUpperCase()}</td>
                                  {[5,4,3,2,1].map(score => (
                                    <td key={score} style={{ border: '1px solid #1976d2', textAlign: 'center', fontSize: 12, color: '#1976d2', fontWeight: 700 }}>
                                      {academicRecord?.domainAssessment?.psychomotor?.[item] === score ? '✓' : ''}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}
                
                {/* Toddler Assessment Summary Section */}
                {showToddlerAssessment && (
                  <div style={{ margin: '1.5rem 0' }}>
                    <p className="section-label" style={{ textAlign: 'center', color: '#1976d2', fontWeight: 700, letterSpacing: 1, marginBottom: 16 }}>
                      TODDLER DEVELOPMENT ASSESSMENT SUMMARY
                    </p>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div style={{ 
                          background: '#f8fbff', 
                          padding: '1rem', 
                          borderRadius: '8px', 
                          border: '1px solid #e3f0ff',
                          marginBottom: '1rem'
                        }}>
                          <div style={{ fontWeight: 600, color: '#1976d2', marginBottom: '0.5rem' }}>
                            Assessment Overview:
                          </div>
                          <div style={{ fontSize: '12px', lineHeight: '1.5' }}>
                            This report provides a comprehensive assessment of the child's developmental progress across various domains including physical development, language & communication, cognitive development, social & emotional skills, self-help abilities, and creative & artistic expression. Each assessment is based on age-appropriate milestones and observational data.
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}
                </div>
              </Container>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AcademicPrintAll;
